// import React, { useContext } from "react";
// import "./header.css";
// import { Link, NavLink } from "react-router-dom";
// import AuthContext from "../../contexts/AuthContext";
// import { FiLogOut } from "react-icons/fi";

// const Header = () => {
//   const { user, logout } = useContext(AuthContext);

//   return (
//     <>
//       <header>
//         <div className="upper-menu-block">
//           <div className="our-container">
//             <div className="inner-container d-flex align-items-center justify-content-between mx-auto">
//               <div className="logo-block my-2">
//                 <Link to={"/"} className="d-block">
//                   <img src="/images/karn-logo.png" alt="" />
//                 </Link>
//               </div>
//               <div className="main-menu">
//                 <nav>
//                   <ul className="p-0 d-flex align-items-center justify-content-center mb-0 nav-links">
//                     {/* <li>
//                       <NavLink to={"/"} className="fs-6 fw-semibold nav-items">
//                         Dashboard
//                       </NavLink>
//                     </li> */}
//                     {/* <li>
//                       <NavLink
//                         to={"/contact-us-details"}
//                         className="fs-6 fw-semibold nav-items"
//                       >
//                         Contact Us
//                       </NavLink>
//                     </li>
//                     <li>
//                       <NavLink
//                         to={"/seo-enquiry-details"}
//                         className="fs-6 fw-semibold nav-items"
//                       >
//                         SEO Enquiry
//                       </NavLink>
//                     </li> */}
//                     <li className="d-flex align-items-center justify-content-center">
//                       <button
//                         className="btn nav-link text-black fs-6 fw-semibold nav-items d-flex align-items-center gap-2"
//                         type="button"
//                         onClick={() => {
//                           logout();
//                         }}
//                       >
//                         <FiLogOut className="text-white fa-user-icon" />
//                         <p className="mb-0 text-white"> Sign Out</p>
//                       </button>
//                     </li>
//                     {/* <div className="user-name-show-login">
//                       <b>
//                         {user && (
//                           <p className="m-0 text-capitalize text-white">
//                             Welcome,{" "}
//                             {user.name || localStorage.getItem("userAdminName")}
//                             !
//                           </p>
//                         )}
//                       </b>
//                     </div> */}
//                   </ul>
//                 </nav>
//               </div>
//             </div>
//           </div>
//         </div>
//       </header>
//     </>
//   );
// };

// export default Header;


// import React, { useContext } from "react";
// import "./header.css";
// import { Link } from "react-router-dom";
// import AuthContext from "../../contexts/AuthContext";
// import { FiLogOut } from "react-icons/fi";

// const Header = () => {
//   const { user, logout } = useContext(AuthContext);

//   return (
//     <header className="admin-header">
//       <div className="upper-menu-block">
//         <div className="our-container">
//           <div className="inner-container d-flex align-items-center justify-content-between mx-auto">
            
//             {/* LOGO → DASHBOARD */}
//             <div className="logo-block my-2">
//               <Link to="/" className="d-block">
//                 <img src="/images/karn-logo.png" alt="KARN Logo" />
//               </Link>
//             </div>

//             {/* RIGHT SIDE */}
//             <div className="header-actions d-flex align-items-center gap-3">
//               {user && (
//                 <span className="admin-name">
//                   Welcome,{" "}
//                   {user.name || localStorage.getItem("userAdminName")}
//                 </span>
//               )}

//               <button
//                 className="logout-btn d-flex align-items-center gap-2"
//                 onClick={logout}
//               >
//                 <FiLogOut size={18} />
//                 <span>Sign Out</span>
//               </button>
//             </div>

//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;

import React, { useContext } from "react";
import "./header.css";
import { Link } from "react-router-dom";
import AuthContext from "../../contexts/AuthContext";
import { FiLogOut } from "react-icons/fi";

const Header = () => {
  const { user, logout } = useContext(AuthContext);

  return (
    <header>
      <div className="upper-menu-block">
        <div className="our-container">
          <div className="inner-container d-flex align-items-center justify-content-between mx-auto">
            
            {/* Logo */}
            <div className="logo-block my-2">
              <Link to="/" className="d-block">
                <img src="/images/karn-logo.png" alt="KARN Admin" />
              </Link>
            </div>

            {/* Right Actions */}
            <div className="header-actions d-flex align-items-center gap-3">
               {user && (
                <span className="admin-name">
                  Welcome{" "}
                  {user.name || localStorage.getItem("userAdminName")}
                </span>
              )}

              <button
                className="logout-btn d-flex align-items-center gap-2"
                onClick={logout}
              >
                <FiLogOut size={18} />
                <span>Sign Out</span>
              </button>
            </div>

          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

